var React = require('react');

function IcConsoleActive (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FF6400","fillRule":"evenodd","d":"M29.333 5H2.667C1.196 5.004.004 6.196 0 7.667v16c.004 1.471 1.196 2.663 2.667 2.667h26.666c1.471-.004 2.663-1.196 2.667-2.667v-16C31.996 6.196 30.804 5.004 29.333 5zM14 17h-4v4H7.333v-4h-4v-2.667h4v-4H10v4h4V17zm7.333 2.667c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2zm5.333-4c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2c0 1.104-.895 2-1.999 2h-.001z"}));
}

IcConsoleActive.defaultProps = {"id":"ic-console-active","viewBox":"0 0 32 32"};

module.exports = IcConsoleActive;

IcConsoleActive.default = IcConsoleActive;
